import { render, staticRenderFns } from "./ProfilePictureModal.vue?vue&type=template&id=01634130&scoped=true"
import script from "./ProfilePictureModal.vue?vue&type=script&lang=js"
export * from "./ProfilePictureModal.vue?vue&type=script&lang=js"
import style0 from "./ProfilePictureModal.vue?vue&type=style&index=0&id=01634130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01634130",
  null
  
)

export default component.exports